import { FaStar, FaRegStar, FaStarHalfAlt } from "react-icons/fa";

const StarRating = ({ reviewLength, averageRating }) => {

  const renderStars = () => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      if (i <= Math.floor(averageRating)) {
        stars.push(<FaStar key={i} size={20} cursor="pointer" title="Rating" color="orange" />);
      } else if (i === Math.ceil(averageRating) && averageRating % 1 !== 0) {
        stars.push(<FaStarHalfAlt key={i} size={20} cursor="pointer" title="Rating" color="orange" />);
      } else {
        stars.push(<FaRegStar key={i} size={20} cursor="pointer" title="Rating" color="orange" />);
      }
    }
    return stars;
  };

  return (
    <div className="flex justify-center items-center gap-0.5 shadow rounded-md px-1">
      {renderStars()}
      <span className="text-md">{reviewLength?.toLocaleString('en-us')}</span>
    </div>
  );
};

export default StarRating;
